import Axios from 'axios';
import { DeveloperMenuSettings, ApiDeveloperMenuSettings } from 'model';
import { DevicePayload, DeviceSystemModePayload, UpdateDevicePayload } from 'model/api';

export const saveDevice = async (deviceId: string, payload: DevicePayload): Promise<any> => {
  const response = await Axios.post(`/devices/${deviceId}`, payload);
  return response.data;
}

export const setDeviceSystemMode = async (deviceId: string, payload: DeviceSystemModePayload): Promise<any> => {
  const response = await Axios.post(`/devices/${deviceId}/systemMode`, payload);
  return response.data;
}

export const getDevice = async (deviceId: string): Promise<any> => {
  const response = await Axios.get(`/devices/${deviceId}`);
  return response.data;
}

export const deleteDevice = async (deviceId: string): Promise<any> => {
  const response = await Axios.delete(`/devices/${deviceId}`);
  return response.data;
}

export const updateDevice = async (deviceId: string, device: UpdateDevicePayload): Promise<any> => {
  const response = await Axios.post(`/devices/${deviceId}`, device);
  return response.data;
}

export const runHealthTest = async (deviceId: string): Promise<any> => {
  const response = await Axios.post(`/devices/${deviceId}/healthTest/run`);
  return response.data;
}

export const updateDeveloperMenuSettings = async (deviceId: string, developerMenuSettings: DeveloperMenuSettings): Promise<any> => {
  const apiDeveloperMenuSettings = {
    player_action: developerMenuSettings.playerAction,
    player_flow: developerMenuSettings.playerFlow,
    player_min_pressure: developerMenuSettings.playerMinPressure,
    player_pressure: developerMenuSettings.playerPressure,
    player_temperature: developerMenuSettings.playerTemperature,
  } as ApiDeveloperMenuSettings;
  
  const response = await Axios.post(`/devices/${deviceId}/fwProperties`, apiDeveloperMenuSettings);
  return response.data;
}